<template>
	<div class="footers">
		<div class="footer">
			<div class="content">
				<div class="left">
					<p class="company_ch">厦门市东合信息技术有限公司</p>
					<p class="company_en">Xiamen Danhar Information Technology Co. Ltd.</p>
					<p class="title_1">智慧法务践行者</p>
				</div>
				<div class="center">
					<p class="concat">联系方式</p>
					<p class="mobile">400-110-0592</p>
					<p class="addr">厦门市海沧区SEC泰地海西中心A703 </p>
					<a style="color: blue" href="https://beian.miit.gov.cn/" target="_blank">闽ICP备14001608号-1</a>
				</div>
				<div class="right">
					<img src="../assets/images/code.png" alt="" class="img_code">
					<p class="tip">数字法治 智慧司法</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer',
	data () {
		return {

		}
	},
	mounted () {
	},
	created () {
		this.ab = ''
	},
	methods: {}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.footers {
	width: 100%;
	margin: 0 auto;
}
.footer {
	height: 340px;
	background: url('../assets/images/footer.png') no-repeat 50%;
	.content {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		color: #fff;
		margin: 0 auto;
		padding: 94px 0px;
		box-sizing: border-box;
		.left {
			text-align: center;
			.company_ch {
				font-size: 20px;
				margin-bottom: 6px;
			}
			.company_en {
				font-size: 12px;
				margin-bottom: 34px;
			}
			.title_1 {
				font-size: 24px;
				letter-spacing: 6px;
			}
		}
		.center {
			.concat {
				margin-top: 6px;
				font-size: 16px;
				margin-bottom: 13px;
			}
			.mobile {
				font-size: 18px;
				letter-spacing: 2px;
				margin-bottom: 29px;
			}
			.addr {
				font-size: 16px;
			}
		}
		.right {
			margin-top: -12px;
			.img_code {
				width: 112px;
				height: 112px;
				margin-bottom: 6px;
			}
			.tip {
				font-size: 12px;
				text-align: center;
			}
		}
	}
}
@media screen and (min-width: 1025px) {
	.footer {
		.content {
			width: 1050px;
		}
	}
}
@media screen and (max-width: 998px) and (min-width: 768px) {
	.footer {
		.content {
			width: auto;
			padding: 80px 0 60px;
			.left {
				.company_ch {
					font-size: 16px;
				}
			}
			.center {
				.concat {
					font-size: 12px;
				}
				.mobile {
					font-size: 11px;
				}
				.addr {
					font-size: 11px;
				}
			}
			.right {
				.img_code {
					width: 60px;
					height: 60px;
				}
				.tip {
					font-size: 10px;
				}
			}
		}
	}
}

@media screen and (max-width: 767px) {
	.footer {
		box-sizing: border-box;
		.content {
			width: 100%;
			padding: 0 20px;
			flex-direction: column;
			box-sizing: border-box;
			div {
				width: 100%;
				flex: 1;
				text-align: center;
				margin: 0 auto;
				box-sizing: border-box;
			}
			.left {
				padding-top: 30px;
				.company_ch {
					font-size: 18px;
					margin-bottom: 3px;
				}
				.company_en {
					font-size: 10px;
					margin-bottom: 10px;
				}
			}
			.center {
				margin-top: 12px;
				.concat {
					margin-top: 10px;
					font-size: 14px;
					margin-bottom: 10px;
				}
				.mobile {
					font-size: 13px;
					letter-spacing: 2px;
					margin-bottom: 10px;
				}
				.addr {
					font-size: 13px;
				}
			}
			.right {
				margin-top: 20px;
				.img_code {
					width: 80px;
					height: 80px;
					margin-bottom: 10px;
				}
				.tip {
					font-size: 12px;
					text-align: center;
				}
			}
		}
	}
}
</style>
